<template>
   <div class="Home" :style="{height:browserHeight + 'px'}">
      <div class="Home-one">
        <el-image
        class="Home-one-img"
        :src="img.OneImg"
        fit="cover">
        </el-image>
        <div class="Home-one-bg">
          <div class="Home-one-center">
            <div class="Home-one-label"> 珠宝行业的智慧零售专家 </div>
            <div class="Home-one-title"> 珠宝新阵地 营销新格局 </div>
            <div class="Home-one-subheading"> 宝来屋 · 云珠宝解决方案 </div>
            <div class="Home-one-line"></div>
            <div class="Home-one-content"> 宝来屋是定位于微信的珠宝门店智慧营销新零售系统，全面融合小程序、个人微信、社群、公众平台，革新传统珠宝零售的流媒体系和CRM体系，助力每一家珠宝门店实现业绩30%的目标 </div>
            <img class="Home-one-mark" src="../assets/img/home/banner_mark.png" alt="banner_mark">
            <div class="Home-one-hint"> 向下滚动 </div>
          </div>
        </div>
      </div>
      <div class="Home-two">
        <div class="Home-two-title"> 解决方案 </div>
        <div class="Home-two-content">
          <div class="Home-two-content-button" v-for="(index) in 3" :key="index"></div>
        </div>
      </div>
      <div class="Home-three">
        <el-row type="flex" class="Home-three-bg" justify="space-around">
          <el-col :span="7" v-for="(data, index) in threeDatas" :key="index">
            <div class="Home-three-box" :style="{background:data.bgColor}">
              <img class="Home-three-box-logo" :src="data.logo" alt="three-logo">
              <div v-for="(data, dindex) in data.datas" :key="index+'-'+dindex">
                <div class="Home-three-box-title">{{data.title}}</div>
                <div style="height:20px"></div>
                <div class="Home-three-box-content">{{data.content}}</div>
                <div :v-if="dindex!=0" style="height:20px"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="Home-four">
        <div class="Home-four-bg">
          <div style="height:100px"></div>
          <img class="Home-four-title" src="../assets/img/home/image5.png" alt="Home-four-title">
        </div>
      </div>
      <div class="Home-five">
        <div class="Home-five-title">服务支持</div>
        <div class="Home-five-bg">
          <div class="Home-five-bg-box">
            <div class="Home-five-bg-box-content-bg">
              <div class="Home-five-bg-box-line"></div>
              <div class="Home-five-bg-box-title">SAAS 技术服务</div>
              <div class="Home-five-bg-box-content"> 线上进店一天搭建 技术团队保障运维<br/>无需技术投入 无需运维人员 低成本高效率<br/>卖货</div>
            </div>
            
          </div>
          <div class="Home-five-bg-box">
            <img class="Home-five-bg-box-image" src="../assets/img/home/image2.png" alt="Home-five-bg-box-img">
          </div>
        </div>
        <div style="height:30px"></div>
        <div class="Home-five-bg">
          <div class="Home-five-bg-box">
            <img class="Home-five-bg-box-image" src="../assets/img/home/image4.png" alt="Home-five-bg-box-img">
          </div>
          <div class="Home-five-bg-box" style="text-align: right;">
            <div class="Home-five-bg-box-content-bg">
              <div class="Home-five-bg-box-line" style="margin-left: 480px"></div>
              <div class="Home-five-bg-box-title">全流程服务</div>
              <div class="Home-five-bg-box-content">售前顾问：制定专属门店解决方案<br/>产品研发：快速响应客户需求及问题<br/>客户运维：7*24小时在线答疑<br/>内容运营：制定专属培训课程</div>
            </div>
          </div>
        </div>
        <div style="height:100px"></div>
      </div>
      <div class="Home-six">
        <div class="Home-six-title"> 免费申请试用<br/>针对店铺运营需求，为您定制专属服务 </div>
      </div>
      <div class="Home-seven">
        <div class="Home-seven-QRCode-bg">
          <img class="Home-seven-QRCode-bg-QRCode" src="../assets/img/home/QRCode.png" alt="Home-seven-image">
        </div>
        <div class="Home-seven-title"> 扫码加客服微信 </div>
      </div>
    </div>
</template>

<script>
import OneImg from "@/assets/img/home/banner.jpeg"
export default {
  components:{
    
  },
  data() {
    return {
      img:{
        OneImg,
      },
      browserHeight: 0,
      threeDatas: [
        {
          logo: require("@/assets/img/home/logo_0.png"),
          bgColor: "#FFF3F1",
          datas:[
            {
              title: "造人",
              content: "人群画像-统一标签-拓客引流-促销转化-用户唤回-推荐裂变",
            },
            {
              title: "管人",
              content: "薪酬管理-职能导购-全员分销",
            },
          ],
        },
        {
          logo: require("@/assets/img/home/logo_1.png"),
          bgColor: "#EDF5FF",
          datas:[
            {
              title: "轻松管理",
              content: "宝物志优质供货商低价供一键上传货品，轻松管理新款排行为产品赋能海量营销图文同步店铺",
            },
          ],
        },
        {
          logo: require("@/assets/img/home/logo_2.png"),
          bgColor: "#E3FFEF",
          datas:[
            {
              title: "海量营销插件",
              content: "海量营销插件定义，精细化运营，超级合伙人全民卖货线上引流裂变，线下到店转化",
            },
          ],
        },
      ],
    }
  },
  mounted(){
    this.browserHeight = document.documentElement.clientHeight - 60;
    window.onresize =()=> {
      this.browserHeight = document.documentElement.clientHeight - 60;
    }
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>
.Home {
    padding:0;
    width: 100%;
    min-width: 1440px;
    &-one{
      width: 100%;
      height: 100%;
      margin: 0 auto;
      position: relative;
      &-img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        // display: flex;
      }
      &-bg {
        width:100%;
        color: #fff;
        position: absolute;
        top:20%;
        bottom: 40px;
        z-index: 99;
        display: flex;
        justify-content: center;
      }
      &-center{
        width: 1400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // background: yellowgreen;
      }
      &-label {
        width: 260px;
        height: 40px;
        background: #FF4D4E;
        border-radius: 20px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 40px;
        text-align: center;
      }
      &-title {
        font-size: 40px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        line-height: 40px;
        padding: 30px 0px 20px 0px;
      }
      &-subheading {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        padding-bottom: 70px;
      }
      &-line {
        width: 52px;
        height: 7px;
        background: #FFFFFF;
      }
      &-content {
        width: 500px;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        line-height: 50px;
        padding-top: 20px;
      }
      &-mark {
        width: 30px;
        margin: 0 auto;
        bottom: 20px;
        position: absolute;
        right: 0;
        left: 0;
      }
      &-hint {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #FFFFFF;
        line-height: 14px;
        bottom: 0px;
        right: 0;
        left: 0;
        text-align: center;
        position: absolute;
      }
    }
    &-two {
      width: 100%;
      height: 830px;
      background: #FFF3F1;
      &-title {
        padding: 60px 0px 60px 0px;
        font-size: 40px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #3D2F2F;
        line-height: 40px;
        text-align: center;
      }
      &-content {
        width: 1440px;
        height: 659px;
        background-image: url("../assets/img/home/solve_precept.png");
        display: flex;
        justify-content: center;
        align-items: center;
        background-repeat: no-repeat;
        background-size: contain;
        margin: 0 auto;
        &-button {
          width: 180px;
          height: 50px;
          margin-top: 448px;
          padding-right: 240px;
          // background-color: #fff;
        }
      }
    }
    &-three {
      width: 100%;
      height: 830px;
      background: #FFFFFF;
      margin: 0 auto;
      display: flex;
      &-bg {
        width: 1460px;
        height: 630px;
        margin: 0 auto;
        margin-top: 100px;
      }
      &-box {
        height: 630px;
        border-radius: 4px;
        text-align: center;
        &-logo {
          width: 173.21px;
          height: 150px;
          // margin-top: 80px;
          padding: 80px 0px;
        }
        &-title {
          font-size: 26px;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #3D2F2F;
        }
        &-content {
          max-width: 350px;
          font-size: 22px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          color: #705555;
          line-height: 40px;
          margin: 0 auto;
        }
      }
    }
    &-four {
      width: 100%;
      height: 400px;
      background-image: url("../assets/img/home/image1.png");
      background-repeat: round;
      &-bg {
        width: 1394px;
        margin: 0 auto;
      }
      &-title {
        width: 100%;
      }
    }
    &-five {
      width: 100%;
      background: #FFF3F1;
      &-title {
        padding-top: 100px;
        padding: 100px 0px 80px 0px;
        font-size: 40px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #3D2F2F;
        line-height: 40px;
        text-align: center;
      }
      &-bg {
        width: 1400px;
        height: 440px;
        margin: 0 auto;
        display: flex;
        &-box {
          width: 700px;
          height: 100%;
          background-color: #fff;
          &-content-bg {
            width: 540px;
            margin: 0 auto;
          }
          &-title {
            width: 100%;
            font-size: 40px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #3D2F2F;
            line-height: 40px;
            padding-top: 24px;
            padding-bottom: 30px;
          }
          &-content {
            width: 100%;
            width: 100%;
            font-size: 22px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #705555;
            line-height: 40px;
          }
          &-line {
            width: 60px;
            height: 6px;
            background: #3D2F2F;
            margin-top: 112px;
          }
          &-image {
            width: 700px;
            height: 100%;
          }
        }
      }
    }
    &-six {
      width: 100%;
      height: 140px;
      background-image: url("../assets/img/home/image3.png");
      display:flex;
      justify-content:center;
      align-items: center;
      &-title {
        font-size: 20px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 32px;
        // margin: auto;
        text-align: center;
      }
    }
    &-seven {
      width: 100%;
      height: 200px;
      background: #2A3540;
      &-QRCode-bg {
        width: 96px;
        height: 96px;
        margin: 0 auto;
        padding-top: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        &-QRCode {
          background-color: azure;
          width: 100%;
          height: 100%;
          padding: 1px;
          // align-self: flex-end;
        }
      }
      &-title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        margin: 0 auto;
        margin-top: 18px;
        text-align: center;
      }
    }
  }
</style>